import { createApp } from 'vue/dist/vue.esm-bundler.js';

import diaperRiskWidgetApp from './vue/diaperRiskWidget.js';

document.addEventListener('DOMContentLoaded', () => {
    const diaperRiskWidgetContainers = document.querySelectorAll('.widget-diaper-risk');

    diaperRiskWidgetContainers.forEach(container => {
        createApp(diaperRiskWidgetApp).mount(container);
    });
});
